import { store } from "aldoo-ra/Store"
import { useEffect, useState } from "react"

const PaymentResultPage = () => {
  const [isClient, setIsClient] = useState(false)
  
  useEffect(() => {
    setIsClient(true)
  }, [])

  if (!isClient) return null

  const PaymentResult = store.getElement
    ? store.getElement("payment-result")
    : null
    
  if (!PaymentResult) return null

  return (
    <>
      <PaymentResult />
    </>
  )
}

export default PaymentResultPage